import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

export type AuthenticatingGetLinkParams =
  /**
   * Authenticating a user
   * `/authenticating`
   */
  {
    page: 'authenticating';
    redirectPath?: string;
  };

export const isAuthenticatingPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  return parts[1] === 'authenticating';
};

export const getLinkForAuthenticating = (
  params: AuthenticatingGetLinkParams
): ValidHref => {
  const pathname: ValidHref = `/authenticating`;
  const searchParams: { redirectPath?: string } = {};

  if ('redirectPath' in params && params.redirectPath) {
    searchParams.redirectPath = params.redirectPath;
  }

  return createUrl({
    pathname,
    searchParams,
  });
};
